import { render, staticRenderFns } from "./TaskStatement.vue?vue&type=template&id=0fb9e023&scoped=true"
import script from "./TaskStatement.vue?vue&type=script&lang=js"
export * from "./TaskStatement.vue?vue&type=script&lang=js"
import style0 from "./TaskStatement.vue?vue&type=style&index=0&id=0fb9e023&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb9e023",
  null
  
)

export default component.exports